import classNames from "classnames";
import { Card } from "../Card";
import { ProductActions } from "../ProductActions";
import { ProductChart } from "../ProductChart";
import styles from "./styles.module.scss";
import { useState } from "react";
import { VariantsList } from "../VariantsList";
import { Details } from "../Details";
import { ChartCOO } from "../../widgets/COO/ChartCOO";
import { ChartCFO } from "../../widgets/CFO/chartCFO";
import { ChartPricing } from "../../widgets/Pricing/ChartPricing";
import { ChartOrganic } from "../../widgets/Organic/ChartOrganic";
import { ChartOverview } from "../../widgets/Overview/ChartOverview";
import { useDashboardStore } from "@pages/Dashboard/store/dashboard.state";

const chartComponents = {
  0: ProductChart,
  1: ChartCOO,
  2: ChartCFO,
  4: ChartPricing,
  5: ChartOrganic,
  7: ChartOverview,
};

export const List = ({ data, currentPage, totalPages, onPageChange }) => {
  const [variantsState, setVariantsState] = useState({});
  const [detailsState, setDetailsState] = useState({});
  const [activeIndices, setActiveIndices] = useState({});

  const toggleVariants = (asin) => {
    setVariantsState((prevState) => ({
      ...prevState,
      [asin]: !prevState[asin],
    }));
  };

  const toggleDetails = (asin) => {
    setDetailsState((prevState) => ({
      ...prevState,
      [asin]: !prevState[asin],
    }));
  };

  const setActiveIndexForItem = (asin, index) => {
    setActiveIndices((prevState) => ({
      ...prevState,
      [asin]: index,
    }));
  };

  return (
    <div className={styles.productsList}>
      {data.map((item) => {
        const isVariants = variantsState[item.asin] || false;
        const isDetails = detailsState[item.asin] || false;
        const activeIndex = activeIndices[item.asin] || 0;
        const ChartComponent = chartComponents[activeIndex] || ProductChart;
        const chartProps = activeIndex === 7 ? { asin: item.asin } : {};

        return (
          <div className={styles.productWrapper} key={item.asin}>
            <div className={styles.product}>
              <Card
                title={item.title}
                asin={item.asin}
                variations={item.variations}
                img={item.img}
                rating={item.rating}
                value={item.value}
                isVariants={isVariants}
                setIsVariants={() => toggleVariants(item.asin)}
                status={item.status}
                variantsCount={item.variants?.length}
                isDetails={isDetails}
                setIsDetails={() => toggleDetails(item.asin)}
              />
              <ChartComponent {...chartProps} />
              {activeIndex === 0 && (
                <ProductActions
                  isDetails={isDetails}
                  setIsOpenModal={() => toggleDetails(item.asin)}
                />
              )}
            </div>
            <div
              className={classNames(styles.collapse, {
                [styles.active]: isVariants || isDetails,
              })}
            >
              {isDetails && (
                <Details
                  activeIndex={activeIndex}
                  setActiveIndex={(index) =>
                    setActiveIndexForItem(item.asin, index)
                  }
                />
              )}
              {isVariants && item.variants && (
                <VariantsList data={item.variants} isDetails={isDetails} />
              )}
            </div>
          </div>
        );
      })}

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            className={styles.paginationButton}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <span className={styles.paginationInfo}>
            {currentPage} / {totalPages}
          </span>
          <button
            className={styles.paginationButton}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};
